
<template>
    <div style="width: 100%; display:block; float:left; clear:both;">

        <div class="row">
            <h3>Your Plan</h3>
            <p style="color: #54AE47; font-weight: 900; font-size: 22px;"><img src="/images/SwingU-Logo-Icon.png" alt="SwingU Premium" width="28px" style="vertical-align: middle;"> Premium {{ getSubscriptionTermLabel }}</p>
        </div>

        <div class="row mt-10">
            <h3 class="mb-10">Renewal</h3>
            <p>{{ viewModel.renewalDate }} - {{ viewModel.renewalDays }} days left</p>
            <!-- <p style="margin-top: -10px;"><a href="#" class="cancel-subscription">Cancel Subscription</a></p> -->
        </div>

        <div class="row payment-wrapper">
            <h3 class="mb-20">Payment</h3>

            <div v-if="!changingCard" class="existing-card-wrapper">
                <img class="icon mr-10" src="/images/payment-icons/visa.png" width="65px" height="37px" />
                <span class="card-number">**** **** **** {{ viewModel.paymentDetails['last4'] }}</span>
                <span class="expiry">Expires: {{ viewModel.paymentDetails['expiry'] }}</span>
            </div>

            <div v-if="changingCard" class="new-card-form-wrapper">
                <div v-show="!stipeElementsMounted" class="loading">Loading...</div>
                <div v-show="stipeElementsMounted" id="card-element"></div>
                <div class="mt-20">
                    <button @click="saveCardDetails()" :disabled="saveInProgress" class="btn-outline-primary float-left">Save Card</button>
                    <button @click="cancelChangeCard()" :disabled="saveInProgress" class="btn-link color-black float-left ml-10">Cancel</button>
                </div>
            </div>

            <div v-if="!changingCard" class="change-card-button-wrapper">
                <button id="card-button" @click="addNewCard()" class="btn-outline-primary float-left">Use Different Card</button>
                <span class="float-right"><img src="/images/lock-icon.png" alt="Secure Lock Icon" width="10px;" style="margin-top: -1px; margin-right: 3px;"> Secure checkout, powered by&nbsp;<a href="https://stripe.com" target="_blank" style="color #666666">Stripe</a></span>
            </div>
        </div>

        <div class="row footer-message-wrapper">
            <hr>
            <p class="mt-20 mb-0">We're here to help. No matter what the issue, don't hesitate to ask. Visit our support site at <a href="https://help.swingu.com" target="_blank">help.swingu.com</a> or email us at <a href="mailto:support@swingu.com" target="_blank">support@swingu.com</a>.</p>
        </div>
    </div>
</template>

<script>
import axios, { Method } from "axios";

export default {
    props: ['viewModel', 'stripePublicKey'],

    data: () => {
        return {
            setupIntent: '',
            debugMessages: [
                'Waiting...',
            ],
            stripe: {},
            cardElement: {},
            changingCard: false,
            stipeElementsMounted: false,
            saveInProgress: false,

            stripeElementStyles: {

            },
        };
    },

    created: function() {
        this.debug('we hit here');
        this.debug(this.paymentDetails);
        this.debug(this.paymentMethods);
    },

    methods: {
        addNewCard: function () {
            this.debug('Sending to stripe...');

            this.changingCard = true;
            this.stipeElementsMounted = false;
            this.getSetupIntent();
        },

        getSetupIntent: function () {
            var self = this;

            axios.get('/account/subscription/get-payment-intent', {

            }).then((response) => {
                self.debug('We received a SUCCESS response');
                self.debug(response.data);
                self.setupIntent = response.data;
                self.triggerStripeElements();
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
                this.changingCard = false;
            });
        },

        triggerStripeElements: function () {
            this.stripe = Stripe(this.stripePublicKey);
            let elements = this.stripe.elements();
            this.cardElement = elements.create('card', {
                style: this.stripeElementStyles
            });
            this.cardElement.mount('#card-element');
            this.stipeElementsMounted = true;
        },

        saveCardDetails: function () {
            this.debug('Saving card details...');

            this.saveInProgress = true;

            var self = this;

            this.setupCardInStripeAndAttachToCustomer();
        },

        setupCardInStripeAndAttachToCustomer: function () {
            var self = this;

            this.stripe.confirmCardSetup(self.setupIntent.client_secret, {
                payment_method: {
                    card: self.cardElement,
                },
            }).then(function (result) {
                if (result.error) {
                    self.debug(result.error.message);
                    self.saveInProgress = false;
                } else {
                    self.debug('Setup succeeded');
                    self.debug('Setup Intent Payment Method: ' + result.setupIntent.payment_method);
                    self.debug('Setup Intent: ' + result.setupIntent);
                    self.attachPaymentMethodToCustomerInStripe(result.setupIntent.payment_method);
                }
            });

        },

        attachPaymentMethodToCustomerInStripe: function (paymentMethodId) {
            var self = this;
            axios.post('/account/subscription/update-customer-card-details', {
                paymentMethodId: paymentMethodId
            }).then((response) => {
                self.debug(response.data);
                self.bindCardDataToViewObject(response.data.card);
                self.changingCard = false;
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        setDefaultPaymentMethod: function (paymentMethodId) {
            this.debug('Setting default payment method to: ' + paymentMethodId);

            var self = this;

            let confirmation = confirm('Are you sure?');

            if (!confirmation) {
                console.log('we declined. Exited.');
                return false;
            }

            axios.post('/account/subscription/set-default-payment-method', {
                paymentMethodId: paymentMethodId
            }).then((response) => {
                self.debug('We have changed the default card');

                var existingRowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.default == true;
                });

                var newRowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.id == paymentMethodId;
                });

                if (existingRowIndex == -1 || newRowIndex == -1) {
                    return false;
                }

                self.paymentMethods[existingRowIndex].default = false;
                self.paymentMethods[newRowIndex].default = true;
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        removePaymentMethod: function (paymentMethodId) {
            this.debug('Deleting payment method: ' + paymentMethodId);

            var self = this;

            let confirmation = confirm('Are you sure?');

            if (!confirmation) {
                console.log('we declined. Exited.');
                return false;
            }

            axios.delete('/account/subscription/delete-customer-card/' + paymentMethodId)
            .then((response) => {
                self.debug('We have deleted the card');

                var rowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.id == paymentMethodId;
                });

                if (rowIndex == -1) {
                    return false;
                }

                self.paymentMethods.splice(rowIndex, 1);
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        cancelChangeCard: function () {
            this.changingCard = false;
        },

        bindCardDataToViewObject: function (card) {
            if (card) {
                this.viewModel.paymentDetails.last4 = card.last4;

                let expiry = (card.expiry) ? card.expiry : this.buildExpiryDate(card.exp_month, card.exp_year);

                this.viewModel.paymentDetails.expiry = expiry;
            }
        },

        buildExpiryDate: function (expiryMonth, expiryYear) {
            return this.leftPadNumber(expiryMonth.toString(), 2) + '/' + this.leftPadNumber(expiryYear.toString(), 2);
        },

        leftPadNumber: function (number, targetLength) {
            while (number.length < targetLength) {
                number = '0' + number;
            }

            return number;
        },

        debug: function (message) {
            // console.log('DEBUG: ', message);
            // this.debugMessages.push(message);
        }
    },

    computed: {
        getSubscriptionTermLabel() {
            return this.viewModel.subscriptionTerm === 'monthly' ?
                'Monthly' : 'Annual';
        }
    },
}
</script>


<style scoped lang="scss">
@import "@/_var.scss";
</style>
